import { useEffect} from "react";
import { useState } from "react";
import { KTCard, useDebounce } from "../../../_metronic/helpers";
import "./style.css";
import axios from "axios";
import { RefundsTable } from "./table/RefundsTable";
import { toast } from "react-toastify";
import { RefundsHeader } from "./header/RefundsHeader";
import { RefundsModal } from "./refundModal/RefundsModal";
import { useAuth } from "../auth";
import { useSearchParams, useNavigate } from "react-router-dom";
import { generateURL } from "../../../_metronic/helpers/utils";


const Index = () => {
  const navigate = useNavigate();
  const { currentUser, haveAccess } = useAuth();
  const [searchParams] = useSearchParams();
  const [refunds, setRefunds] = useState([]);
  const [total, setTotal] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isOpenRefundsModal, setOpenRefundsModal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchType, setSearchType] = useState('reservation_code');
  const [searchValue, setSearchValue] = useState(undefined);
  const searchParamSearchType = searchParams.get("search_type");
  const searchParamSearch = searchParams.get("search");
  const searchParamPage = searchParams.get("page")
  const searchParamPageSize = searchParams.get("page_size")
  const [lastLocation, setLastLocation] = useState('/refunds');

    useEffect(() => {
    if(searchParamSearchType || searchParamSearch){
      setSearchType(searchParamSearchType ? searchParamSearchType : 'reservation_code')
      setSearchValue(searchParamSearch ? searchParamSearch : '')
      setPage(searchParamPage ? parseInt(searchParamPage) : 1)
      setPageSize(searchParamPageSize ? parseInt(searchParamPageSize) : 10)
    }else{
      setSearchType('reservation_code')
      setSearchValue('')
      setPage(1)
      setPageSize(10)
    }
  }, [searchParams])

  const fetchRefunds = async () => {
    setLoading(true)
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_V2_URL}/booking/cancellation?page=${page}&page_size=${pageSize}` +
      `${(searchType && debouncedSearchTerm) ?
      `&${searchType}=${debouncedSearchTerm?.trim()}` : ""}`
      );
      setRefunds(data.data);
      setTotal(data.total);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Could not fetch refunds');
    } finally {
      setLoading(false)
    }
  }

  const debouncedSearchTerm = useDebounce(searchValue, 700);
      useEffect(() => {
        if (debouncedSearchTerm !== undefined && searchValue !== undefined) {
          const newUrl = generateURL('/refunds', {
            search_type: searchType,
            search: debouncedSearchTerm?.trim(),
            page: page,
            page_size: pageSize
          })
          if (lastLocation && lastLocation !== newUrl) {
            navigate(newUrl)
            fetchRefunds();
          }
          setLastLocation(newUrl)
          }
  }, [debouncedSearchTerm, page, pageSize, total]);

useEffect(() => {
  if(total && (Math.ceil(total / pageSize) < page)){
    setPage(1);
  }
},[total, page])

  return (
    ((haveAccess(currentUser,  'booking_list') && haveAccess(currentUser,  'booking_cancel'))) ?
      <KTCard>
        <RefundsHeader
          searchType={searchType}
          setSearchType={setSearchType}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
        <RefundsTable
          refunds={refunds}
          total={total}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fetchRefunds={fetchRefunds}
        />
        {isOpenRefundsModal && (
          <RefundsModal
            setOpenRefundsModal={setOpenRefundsModal}
            fetchRefunds={fetchRefunds}
          />
        )}
      </KTCard>
      :
      <KTCard>
        <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
          You do not have permission to view
        </div>
      </KTCard>

  );
};

export default Index;
